import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/models/user';
import { EstensioneService } from 'src/app/services/estensione.service';
import { ToastrService } from 'ngx-toastr';
import { extensions } from '../config';
import { Estensione } from 'src/app/models/estensione';
import { CompagniaService } from 'src/app/services/compagnia.service';
import { Compagnia } from 'src/app/models/compagnia';

@Component({
  selector: 'app-chat-agenzia-liquidatore-ext',
  templateUrl: './chat-agenzia-liquidatore.component.html',
})
export class ChatAgenziaLiquidatoreExtComponent implements OnInit {

  slug: string = 'chat_agenzia_liquidatore';
  form: FormGroup;
  loggedInUser: User;
  extension: Estensione | null;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private estensioneService: EstensioneService,
    private toast: ToastrService,
    private compagniaService: CompagniaService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.loggedInUser = this.authService.loggedInUser.getValue();

    this.form = this.fb.group({
      compagnie: null,
    });

    try {
      this.extension = await this.estensioneService.bySlug(extensions[this.slug]);

      if (this.extension && this.extension.id) {
        await this.patchCompagnie(this.extension.configuration?.compagnia_ids);
      }
    } catch (err) {
      console.error(err);
    }
  }

  private async patchCompagnie(ids?: number[] | null) {
    if (!ids || !ids.length) return;
    try {
      const compagnie = await Promise.all(
        ids.map(id => this.compagniaService.getOne(id))
      );
      const items = compagnie.filter(c => !!c).map(c => ({
        id: c.id,
        humanIdentifier: c.nome,
        nome: c.nome,
      }));
      this.form.patchValue({ compagnie: items });
    } catch (err) {
      console.error(err);
    }
  }

  async Salva() {
    const compagnieValue = this.form?.value.compagnie;
    let compagnia_ids: number[] = [];

    if (Array.isArray(compagnieValue)) {
      compagnia_ids = compagnieValue.map(c => c.id || c).filter(id => !!id);
    }

    const conf = JSON.stringify({ compagnia_ids });

    const params = {
      slug: extensions[this.slug],
      configuration: conf,
      enabled: compagnia_ids.length > 0,
      studio_id: this.loggedInUser.studio_id,
    };

    try {
      const res = await this.estensioneService.saveOrUpdate(params, this.slug);

      if (res.created && res.updated) {
        return this.toast.error('Errore nel server');
      }

      if (res.created) {
        return this.toast.success('Configurazione creata');
      }

      if (res.updated) {
        return this.toast.success('Configurazione salvata');
      }
    } catch (err) {
      console.error(err);
      return this.toast.error('Impossibile salvare la configurazione');
    }
  }
}
